import { useI18n } from 'vue-i18n'
import columnStore from '@/stores/column'

export default function useDashboardColumns(component = 'dashboard') {
	const i18n = useI18n()
	const cols = columnStore()

	const responsible = cols.define(component, 'responsible', i18n.t('responsible'), true)
	const methodCount = cols.define(component, 'method_count', i18n.t('methods'), true)
	const price = cols.define(component, 'price', i18n.t('price'), true)
	const changeCount = cols.define(component, 'change_count', i18n.t('responsibleCost.changes'), true)
	const overdueDates = cols.define(component, 'overdue_dates', i18n.t('date.overdue'), true)

	const columns = {
		responsible,
		methodCount,
		price,
		changeCount,
		overdueDates,
	}

	const { all } = cols.finalize(component, columns)

	return { columns, all }
}
